var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-row" },
    [
      _vm._l(_vm.networks, function(network) {
        return _c(
          "div",
          { key: network.network, staticClass: "social-row__item" },
          [
            _c(
              "share-network",
              {
                staticClass: "share-link",
                style: { backgroundColor: network.color },
                attrs: {
                  network: network.network,
                  url: _vm.sharing.url,
                  title: _vm.sharing.title,
                  description: _vm.sharing.description,
                  quote: _vm.sharing.quote,
                  hashtags: _vm.sharing.hashtags,
                  twitterUser: _vm.sharing.twitterUser
                }
              },
              [_c("i", { staticClass: "icon", class: "" + network.icon })]
            )
          ],
          1
        )
      }),
      _c("div", { staticClass: "social-row__item" }, [
        _c(
          "i",
          {
            directives: [
              {
                name: "clipboard",
                rawName: "v-clipboard:copy",
                value: _vm.params.url,
                expression: "params.url",
                arg: "copy"
              },
              {
                name: "clipboard",
                rawName: "v-clipboard:success",
                value: _vm.onCopy,
                expression: "onCopy",
                arg: "success"
              }
            ],
            staticClass: "share-link share-link--black",
            attrs: { title: _vm._("Copy link") }
          },
          [_c("i", { staticClass: "icon icon--type_copy" })]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cd47932", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd47932","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Uploader/Sharing.vue
// module id = 994
// module chunks = 0